import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a4ff0a9ffe4d3aa9331eb32013f24a5cdb from "./generated-55c70c2d-25f4-4d1f-9a92-8747ef7777f3.json";

import a365a8915094a8e37315b3b2ac9dacaf4b from "./generated-d941405a-d27a-476e-bbd4-a8641f08f060.json";

import a978a4f4307bb73f08ed2d795ff867a6eb from "./generated-58c25eb2-1974-4325-a222-50b94a0da8a4.json";

import ad0baaadb13aca0bd32e37812c764c299b from "./generated-e225de12-eaf8-4589-9145-c23e54411b00.json";

import a0181438a59ca0e35d6613ac0dd87cf99b from "./generated-6f9a2163-a58b-4937-a559-5f1246e2c0b1.json";

import ac8962060dbd6f1176ee6cee5e226f66db from "./generated-37bc4c5e-d24d-4247-9531-d66f9b00f496.json";

import a3863fdfa59b095a4e862cd315863a25bb from "./generated-9b1901d1-dba7-44d3-ba04-ce4f20ad6a45.json";

import a7b4ab0add55f58c7c9f96d34d846baffb from "./generated-bc0b7479-a5bb-43e4-b5b8-4ebe350d11a5.json";

import adae631ef4695fa64d69dd111127b03bfb from "./generated-493ba33a-4f0f-42a8-b149-b4fdd0281d0e.json";

import a68f65886e5c612fd4353cb2d49653ed3b from "./generated-ab6c07ae-6801-47de-a7b8-8796c41cb67e.json";

import a20072ff82478a6374578fbbb6551b789b from "./generated-7a6c4955-38b3-42af-8f8c-c53853fc7f2d.json";

import ae56f23011db4084b6fa83b698e9d4f48b from "./generated-14ad93c5-f4a0-46c5-bd15-581ba640be66.json";

import a24b441abb378a37caa96f64df2a7ea8ab from "./generated-a405c5b1-197a-4208-a44e-175052f69575.json";

import a2c5951f9fecf26061252c99aac12efe6b from "./generated-cfaf6973-17c4-419a-9fc5-b875ca36c44e.json";

import a5d9f199dd8042e1795bb4661d888ca59b from "./generated-9d645421-4564-4ef1-95cb-6bb9e2e4505f.json";

import a9467aaa1606c170c3dd6279ef2f8726db from "./generated-e5b820ed-9c59-47d5-b652-fc6d28a70dc0.json";

import a2eb6d430f50527aac57cc546e866225eb from "./generated-8075afb3-6c3b-44b2-ab1e-3f4a108c355e.json";

import ae1e9b538f4b96c1bb282b5347de04d97b from "./generated-f07fed06-4d3e-42a1-a1b2-60966e11eeda.json";

import aaa6a0d625edd4a38cee94c5d13e23f02b from "./generated-aee6648b-095d-4c45-b3be-0b726bf2206e.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a4ff0a9ffe4d3aa9331eb32013f24a5cdb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a365a8915094a8e37315b3b2ac9dacaf4b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a978a4f4307bb73f08ed2d795ff867a6eb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ad0baaadb13aca0bd32e37812c764c299b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a0181438a59ca0e35d6613ac0dd87cf99b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ac8962060dbd6f1176ee6cee5e226f66db);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a3863fdfa59b095a4e862cd315863a25bb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a7b4ab0add55f58c7c9f96d34d846baffb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(adae631ef4695fa64d69dd111127b03bfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a68f65886e5c612fd4353cb2d49653ed3b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a20072ff82478a6374578fbbb6551b789b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ae56f23011db4084b6fa83b698e9d4f48b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a24b441abb378a37caa96f64df2a7ea8ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a2c5951f9fecf26061252c99aac12efe6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a5d9f199dd8042e1795bb4661d888ca59b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a9467aaa1606c170c3dd6279ef2f8726db);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a2eb6d430f50527aac57cc546e866225eb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ae1e9b538f4b96c1bb282b5347de04d97b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aaa6a0d625edd4a38cee94c5d13e23f02b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a2eb6d430f50527aac57cc546e866225eb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */